// ============================================
// CSS-BASED ANIMATIONS
// ============================================

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', () => {
  const removeLottieWhiteBackground = (svgElement) => {
    if (!svgElement) {
      return;
    }

    const normalizeColor = (value) => {
      if (!value) {
        return null;
      }
      const normalized = value.trim().toLowerCase();
      if (normalized === 'white' || normalized === '#fff' || normalized === '#ffffff') {
        return [1, 1, 1];
      }
      const hexMatch = normalized.match(/^#([0-9a-f]{6})$/);
      if (hexMatch) {
        const hex = hexMatch[1];
        return [
          parseInt(hex.slice(0, 2), 16) / 255,
          parseInt(hex.slice(2, 4), 16) / 255,
          parseInt(hex.slice(4, 6), 16) / 255
        ];
      }
      const rgbMatch = normalized.match(/^rgba?\(([^)]+)\)$/);
      if (rgbMatch) {
        const parts = rgbMatch[1].split(',').map((part) => parseFloat(part.trim()));
        if (parts.length >= 3) {
          return [parts[0] / 255, parts[1] / 255, parts[2] / 255];
        }
      }
      return null;
    };

    const isWhiteish = (value) => {
      const color = normalizeColor(value);
      return color ? color.every((channel) => channel >= 0.95) : false;
    };

    const getStyleFill = (node) => {
      const styleAttr = node.getAttribute('style');
      if (!styleAttr) {
        return null;
      }
      const match = styleAttr.match(/fill:\s*([^;]+)/i);
      return match ? match[1].trim() : null;
    };

    svgElement.style.backgroundColor = 'transparent';
    svgElement.style.background = 'transparent';

    const viewBox = svgElement.viewBox && svgElement.viewBox.baseVal;
    const svgWidth = viewBox ? viewBox.width : parseFloat(svgElement.getAttribute('width'));
    const svgHeight = viewBox ? viewBox.height : parseFloat(svgElement.getAttribute('height'));

    svgElement.querySelectorAll('rect').forEach((rect) => {
      const widthAttr = rect.getAttribute('width');
      const heightAttr = rect.getAttribute('height');
      const width = widthAttr ? parseFloat(widthAttr) : null;
      const height = heightAttr ? parseFloat(heightAttr) : null;
      const isFullSize =
        widthAttr === '100%' ||
        heightAttr === '100%' ||
        (svgWidth && width && Math.abs(width - svgWidth) < 1 && svgHeight && height && Math.abs(height - svgHeight) < 1);
      const fill = rect.getAttribute('fill') || getStyleFill(rect);
      if (isFullSize || isWhiteish(fill)) {
        rect.setAttribute('fill', 'none');
        rect.style.fill = 'none';
        rect.style.background = 'transparent';
      }
    });

    svgElement.querySelectorAll('rect, path').forEach((node) => {
      const fill = node.getAttribute('fill') || getStyleFill(node);
      if (!fill) {
        return;
      }
      if (isWhiteish(fill)) {
        node.setAttribute('fill', 'none');
        node.style.fill = 'none';
      }
    });
  };

  // Initialize Lottie animation for bambino - approccio completamente nuovo
  const initBambinoLottie = async () => {
    const bambinoLottieContainer = document.getElementById('bambino-lottie');
    if (!bambinoLottieContainer) {
      console.error('Bambino Lottie container not found!');
      return;
    }
    
    console.log('Container found:', bambinoLottieContainer);
    
    // Check if Lottie is loaded
    if (typeof lottie === 'undefined') {
      console.error('Lottie library not loaded!');
      setTimeout(initBambinoLottie, 500);
      return;
    }
    
    console.log('Lottie library loaded, loading JSON...');
    
    // Get the animation URL from the data attribute
    const animationUrl = bambinoLottieContainer.getAttribute('data-animation-url');
    if (!animationUrl) {
      console.error('Animation URL not found in data-animation-url attribute!');
      return;
    }
    
    try {
      const response = await fetch(animationUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const animationData = await response.json();
      console.log('✅ JSON loaded successfully');
      
      // Crea l'animazione - l'SVG sarà nascosto dal CSS finché non è pronto
      const bambinoAnimation = lottie.loadAnimation({
        container: bambinoLottieContainer,
        renderer: 'svg',
        loop: true,
        autoplay: false,
        animationData: animationData
      });
      
      console.log('✅ Lottie animation instance created');
      
      // Quando il DOM è caricato, aspetta che l'SVG sia completamente renderizzato
      bambinoAnimation.addEventListener('DOMLoaded', () => {
        console.log('✅ Bambino Lottie DOM loaded');
        // Aspetta che l'SVG sia completamente renderizzato (doppio RAF)
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            // Ora mostra il container e l'SVG con fade in
            bambinoLottieContainer.style.visibility = 'visible';
            bambinoLottieContainer.classList.add('animate-in');
            // Avvia l'animazione
            setTimeout(() => {
              bambinoAnimation.play();
              console.log('✅ Bambino Lottie animation started');
            }, 300); // Delay per assicurarsi che il fade in sia iniziato
          });
        });
      });
      
      bambinoAnimation.addEventListener('data_ready', () => {
        console.log('✅ Bambino Lottie animation data ready');
      });
      
      bambinoAnimation.addEventListener('data_failed', (error) => {
        console.error('❌ Failed to load animation data:', error);
      });
      
    } catch (error) {
      console.error('❌ Error loading Lottie animation:', error);
      // Fallback: try with path (might work if served via HTTP server)
      try {
        const fallbackAnimation = lottie.loadAnimation({
          container: bambinoLottieContainer,
          renderer: 'svg',
          loop: true,
          autoplay: false, // Anche qui autoplay false
          path: 'assets/animations/bambino.json'
        });
        console.log('⚠️ Using fallback path method');
        
        // Gestisci anche il fallback
        fallbackAnimation.addEventListener('DOMLoaded', () => {
          requestAnimationFrame(() => {
            bambinoLottieContainer.style.opacity = '1';
            bambinoLottieContainer.style.visibility = 'visible';
            bambinoLottieContainer.classList.add('animate-in');
            requestAnimationFrame(() => {
              fallbackAnimation.play();
            });
          });
        });
      } catch (fallbackError) {
        console.error('❌ Fallback also failed:', fallbackError);
      }
    }
  };
  
  // Wait for window load to ensure everything is ready
  if (document.readyState === 'loading') {
    window.addEventListener('load', () => {
      setTimeout(initBambinoLottie, 100);
    });
  } else {
    setTimeout(initBambinoLottie, 100);
  }

  // Initialize Lottie animation for bird
  const initBirdLottie = async () => {
    const birdLottieContainer = document.getElementById('bird-lottie');
    if (!birdLottieContainer) {
      console.error('Bird Lottie container not found!');
      return;
    }
    
    console.log('Bird container found:', birdLottieContainer);
    
    // Check if Lottie is loaded
    if (typeof lottie === 'undefined') {
      console.error('Lottie library not loaded!');
      setTimeout(initBirdLottie, 500);
      return;
    }
    
    console.log('Lottie library loaded, loading bird JSON...');
    
    // Get the animation URL from the data attribute
    const animationUrl = birdLottieContainer.getAttribute('data-animation-url');
    if (!animationUrl) {
      console.error('Bird animation URL not found in data-animation-url attribute!');
      return;
    }
    
    try {
      const response = await fetch(animationUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const animationData = await response.json();
      console.log('✅ Bird JSON loaded successfully');
      
      // Create the animation
      const birdAnimation = lottie.loadAnimation({
        container: birdLottieContainer,
        renderer: 'svg',
        loop: true,
        autoplay: false,
        animationData: animationData
      });
      
      console.log('✅ Bird Lottie animation instance created');
      
      // When DOM is loaded, wait for SVG to be fully rendered
      birdAnimation.addEventListener('DOMLoaded', () => {
        console.log('✅ Bird Lottie DOM loaded');
        // Wait for SVG to be completely rendered (double RAF)
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            // Add animate-in class if not already present (entrance animation handles visibility/opacity)
            if (!birdLottieContainer.classList.contains('animate-in')) {
              birdLottieContainer.style.visibility = 'visible';
              birdLottieContainer.classList.add('animate-in');
            }
            // Start the animation
            setTimeout(() => {
              birdAnimation.play();
              console.log('✅ Bird Lottie animation started');
            }, 300); // Delay to ensure fade in has started
          });
        });
      });
      
      birdAnimation.addEventListener('data_ready', () => {
        console.log('✅ Bird Lottie animation data ready');
      });
      
      birdAnimation.addEventListener('data_failed', (error) => {
        console.error('❌ Failed to load bird animation data:', error);
      });
      
    } catch (error) {
      console.error('❌ Error loading bird Lottie animation:', error);
      // Fallback: try with path (might work if served via HTTP server)
      try {
        const fallbackAnimation = lottie.loadAnimation({
          container: birdLottieContainer,
          renderer: 'svg',
          loop: true,
          autoplay: false,
          path: 'assets/animations/bird.json'
        });
        console.log('⚠️ Using fallback path method for bird');
        
        // Handle fallback
        fallbackAnimation.addEventListener('DOMLoaded', () => {
          requestAnimationFrame(() => {
            birdLottieContainer.style.opacity = '1';
            birdLottieContainer.style.visibility = 'visible';
            birdLottieContainer.classList.add('animate-in');
            requestAnimationFrame(() => {
              fallbackAnimation.play();
            });
          });
        });
      } catch (fallbackError) {
        console.error('❌ Bird fallback also failed:', fallbackError);
      }
    }
  };
  
  // Wait for window load to ensure everything is ready
  if (document.readyState === 'loading') {
    window.addEventListener('load', () => {
      setTimeout(initBirdLottie, 100);
    });
  } else {
    setTimeout(initBirdLottie, 100);
  }

  // Initialize Lottie animation for turtle (tartaruga)
  const initTartarugaLottie = async () => {
    const tartarugaLottieContainer = document.getElementById('tartaruga-lottie');
    if (!tartarugaLottieContainer) {
      console.error('Tartaruga Lottie container not found!');
      return;
    }
    
    console.log('Tartaruga container found:', tartarugaLottieContainer);
    
    // Check if Lottie is loaded
    if (typeof lottie === 'undefined') {
      console.error('Lottie library not loaded!');
      setTimeout(initTartarugaLottie, 500);
      return;
    }
    
    console.log('Lottie library loaded, loading tartaruga JSON...');
    
    // Get the animation URL from the data attribute
    const animationUrl = tartarugaLottieContainer.getAttribute('data-animation-url');
    if (!animationUrl) {
      console.error('Tartaruga animation URL not found in data-animation-url attribute!');
      return;
    }
    
    try {
      const response = await fetch(animationUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const animationData = await response.json();
      console.log('✅ Tartaruga JSON loaded successfully');
      
      // Create the animation
      const tartarugaAnimation = lottie.loadAnimation({
        container: tartarugaLottieContainer,
        renderer: 'svg',
        loop: true,
        autoplay: false,
        animationData: animationData,
        rendererSettings: {
          clearCanvas: true,
          preserveAspectRatio: 'xMidYMid meet'
        }
      });
      
      // Ensure transparent background
      tartarugaLottieContainer.style.backgroundColor = 'transparent';
      
      console.log('✅ Tartaruga Lottie animation instance created');
      
      // When DOM is loaded, wait for SVG to be fully rendered
      tartarugaAnimation.addEventListener('DOMLoaded', () => {
        console.log('✅ Tartaruga Lottie DOM loaded');
        // Turtle: do not apply white-background removal (only applied to sun/solo Lotties)
        // Wait for SVG to be completely rendered (double RAF)
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            // Now show the container and SVG with fade in
            tartarugaLottieContainer.style.visibility = 'visible';
            tartarugaLottieContainer.classList.add('animate-in');
            // Start the animation
            setTimeout(() => {
              tartarugaAnimation.play();
              console.log('✅ Tartaruga Lottie animation started');
            }, 300); // Delay to ensure fade in has started
          });
        });
      });
      
      tartarugaAnimation.addEventListener('data_ready', () => {
        console.log('✅ Tartaruga Lottie animation data ready');
      });
      
      tartarugaAnimation.addEventListener('data_failed', (error) => {
        console.error('❌ Failed to load tartaruga animation data:', error);
      });
      
    } catch (error) {
      console.error('❌ Error loading tartaruga Lottie animation:', error);
      // Fallback: try with path (might work if served via HTTP server)
      try {
        const fallbackAnimation = lottie.loadAnimation({
          container: tartarugaLottieContainer,
          renderer: 'svg',
          loop: true,
          autoplay: false,
          path: 'assets/animations/tartaruga.json',
          rendererSettings: {
            clearCanvas: true,
            preserveAspectRatio: 'xMidYMid meet'
          }
        });
        console.log('⚠️ Using fallback path method for tartaruga');
        
        // Ensure transparent background
        tartarugaLottieContainer.style.backgroundColor = 'transparent';
        
        // Handle fallback
        fallbackAnimation.addEventListener('DOMLoaded', () => {
          // Turtle: do not apply white-background removal
          requestAnimationFrame(() => {
            tartarugaLottieContainer.style.opacity = '1';
            tartarugaLottieContainer.style.visibility = 'visible';
            tartarugaLottieContainer.classList.add('animate-in');
            requestAnimationFrame(() => {
              fallbackAnimation.play();
            });
          });
        });
      } catch (fallbackError) {
        console.error('❌ Tartaruga fallback also failed:', fallbackError);
      }
    }
  };
  
  // Wait for window load to ensure everything is ready
  if (document.readyState === 'loading') {
    window.addEventListener('load', () => {
      setTimeout(initTartarugaLottie, 100);
    });
  } else {
    setTimeout(initTartarugaLottie, 100);
  }

  // Initialize Lottie animations for solo stars in reviews section
  const initSoloLotties = async () => {
    const soloLottieContainers = document.querySelectorAll('.solo-lottie');
    if (soloLottieContainers.length === 0) {
      console.log('No solo Lottie containers found');
      return;
    }
    
    console.log(`Found ${soloLottieContainers.length} solo Lottie containers`);
    
    // Check if Lottie is loaded
    if (typeof lottie === 'undefined') {
      console.error('Lottie library not loaded!');
      setTimeout(initSoloLotties, 500);
      return;
    }
    
    console.log('Lottie library loaded, initializing solo animations...');
    
    // Initialize each solo animation
    soloLottieContainers.forEach((container, index) => {
      const animationUrl = container.getAttribute('data-animation-url');
      if (!animationUrl) {
        console.error(`Solo animation URL not found for container ${index + 1}`);
        return;
      }
      
      // Load and initialize each animation
      (async () => {
        try {
          const response = await fetch(animationUrl);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const animationData = await response.json();
          console.log(`✅ Solo ${index + 1} JSON loaded successfully`);
          
          // Create the animation
          const soloAnimation = lottie.loadAnimation({
            container: container,
            renderer: 'svg',
            loop: true,
            autoplay: false,
            animationData: animationData,
            rendererSettings: {
              clearCanvas: true,
              preserveAspectRatio: 'xMidYMid meet'
            }
          });
          
          // Ensure transparent background
          container.style.backgroundColor = 'transparent';
          
          console.log(`✅ Solo ${index + 1} Lottie animation instance created`);
          
          // When DOM is loaded, wait for SVG to be fully rendered
          soloAnimation.addEventListener('DOMLoaded', () => {
            console.log(`✅ Solo ${index + 1} Lottie DOM loaded`);
            // Ensure SVG has transparent background
            const svg = container.querySelector('svg');
            removeLottieWhiteBackground(svg);
            // Wait for SVG to be completely rendered (double RAF)
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                // Now show the container and SVG with fade in
                container.style.visibility = 'visible';
                container.classList.add('animate-in');
                // Start the animation
                setTimeout(() => {
                  soloAnimation.play();
                  console.log(`✅ Solo ${index + 1} Lottie animation started`);
                }, 300 + (index * 100)); // Stagger animations slightly
              });
            });
          });
          
          soloAnimation.addEventListener('data_ready', () => {
            console.log(`✅ Solo ${index + 1} Lottie animation data ready`);
          });
          
          soloAnimation.addEventListener('data_failed', (error) => {
            console.error(`❌ Failed to load solo ${index + 1} animation data:`, error);
          });
          
        } catch (error) {
          console.error(`❌ Error loading solo ${index + 1} Lottie animation:`, error);
          // Fallback: try with path
          try {
            const fallbackAnimation = lottie.loadAnimation({
              container: container,
              renderer: 'svg',
              loop: true,
              autoplay: false,
              path: 'assets/animations/sole.json',
              rendererSettings: {
                clearCanvas: true,
                preserveAspectRatio: 'xMidYMid meet'
              }
            });
            console.log(`⚠️ Using fallback path method for solo ${index + 1}`);
            
            // Ensure transparent background
            container.style.backgroundColor = 'transparent';
            
            // Handle fallback
            fallbackAnimation.addEventListener('DOMLoaded', () => {
              // Ensure SVG has transparent background
              const svg = container.querySelector('svg');
              removeLottieWhiteBackground(svg);
              requestAnimationFrame(() => {
                container.style.opacity = '1';
                container.style.visibility = 'visible';
                container.classList.add('animate-in');
                requestAnimationFrame(() => {
                  fallbackAnimation.play();
                });
              });
            });
          } catch (fallbackError) {
            console.error(`❌ Solo ${index + 1} fallback also failed:`, fallbackError);
          }
        }
      })();
    });
  };
  
  // Wait for window load to ensure everything is ready
  if (document.readyState === 'loading') {
    window.addEventListener('load', () => {
      setTimeout(initSoloLotties, 100);
    });
  } else {
    setTimeout(initSoloLotties, 100);
  }

  // Hero animations - trigger immediately
  setTimeout(() => {
    const heroLogo = document.querySelector('.hero__logo');
    const heroTitle = document.querySelector('.hero__title');
    const heroDescription = document.querySelector('.hero__description');
    const heroButtons = document.querySelectorAll('.hero__button-container .dot__button');
    const heroFeatures = document.querySelectorAll('.hero__feature-item');
    const heroIllustration = document.querySelector('.hero__illustration-placeholder');
    const heroNuvola = document.querySelector('.hero__nuvola');
    const heroBird = document.querySelector('.hero__bird');
    const heroBambino = document.querySelector('.hero__bambino');
    const heroStella = document.querySelector('.hero__stella');

    // Add animate-in class to trigger CSS animations
    if (heroLogo) {
      heroLogo.style.opacity = '';
      heroLogo.classList.add('animate-in');
    }
    if (heroTitle) {
      heroTitle.style.opacity = '';
      heroTitle.classList.add('animate-in');
    }
    if (heroDescription) {
      // Remove inline style to allow CSS animation to work
      heroDescription.style.opacity = '';
      heroDescription.classList.add('animate-in');
    }
    heroButtons.forEach(btn => {
      btn.style.opacity = '';
      btn.classList.add('animate-in');
    });
    heroFeatures.forEach(feature => {
      feature.style.opacity = '';
      feature.classList.add('animate-in');
    });
    if (heroIllustration) {
      heroIllustration.style.opacity = '';
      heroIllustration.classList.add('animate-in');
    }
    if (heroNuvola) {
      heroNuvola.style.opacity = '';
      heroNuvola.classList.add('animate-in');
    }
    if (heroBird) {
      heroBird.style.opacity = '';
      heroBird.style.visibility = 'visible';
      heroBird.classList.add('animate-in');
    }
    if (heroBambino) {
      heroBambino.style.opacity = '';
      heroBambino.classList.add('animate-in');
    }
    if (heroStella) {
      heroStella.style.opacity = '';
      heroStella.classList.add('animate-in');
    }
  }, 100);

  // Section Offer animations - trigger when in view
  const observerOptions = {
    root: null,
    rootMargin: '-100px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const sectionOfferLabel = document.querySelector('.section-offer__label');
        const sectionOfferTitle = document.querySelector('.section-offer__title');
        const sectionOfferDescription = document.querySelector('.section-offer__description');
        const sectionOfferSubdescription = document.querySelector('.section-offer__subdescription');
        const sectionOfferButton = document.querySelector('.section-offer__button-container .dot__button');
        const sectionOfferNote = document.querySelector('.section-offer__note');
        const sectionOfferImage = document.querySelector('.section-offer__image');

        // Add animate-in class to trigger CSS animations
        if (sectionOfferLabel) sectionOfferLabel.classList.add('animate-in');
        if (sectionOfferTitle) sectionOfferTitle.classList.add('animate-in');
        if (sectionOfferDescription) sectionOfferDescription.classList.add('animate-in');
        if (sectionOfferSubdescription) sectionOfferSubdescription.classList.add('animate-in');
        if (sectionOfferButton) sectionOfferButton.classList.add('animate-in');
        if (sectionOfferNote) sectionOfferNote.classList.add('animate-in');
        if (sectionOfferImage) sectionOfferImage.classList.add('animate-in');

        // Stop observing once animated
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe the section offer header
  const sectionOfferHeader = document.querySelector('.section-offer__header');
  if (sectionOfferHeader) {
    observer.observe(sectionOfferHeader);
  }

  // Last Call Section animations - trigger when in view
  const lastCallObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const lastCallButtons = document.querySelectorAll('.last-call-section__buttons .dot__button');
        lastCallButtons.forEach(btn => {
          btn.style.opacity = '';
          btn.classList.add('animate-in');
        });

        // Stop observing once animated
        lastCallObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe the last call section buttons container
  const lastCallButtonsContainer = document.querySelector('.last-call-section__buttons');
  if (lastCallButtonsContainer) {
    lastCallObserver.observe(lastCallButtonsContainer);
  }

  // Pack Section animations - trigger when in view
  const packObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const packButtons = document.querySelectorAll('.pack-section__packages .dot__button, .pack-section__custom-container .dot__button');
        packButtons.forEach(btn => {
          btn.style.opacity = '';
          btn.classList.add('animate-in');
        });

        // Stop observing once animated
        packObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe the pack section packages wrapper
  const packPackagesWrapper = document.querySelector('.pack-section__packages-wrapper');
  const packCustomContainer = document.querySelector('.pack-section__custom-container');
  if (packPackagesWrapper) {
    packObserver.observe(packPackagesWrapper);
  }
  if (packCustomContainer) {
    packObserver.observe(packCustomContainer);
  }

  // Themes Container animations - trigger when in view (stessa logica di section-offer)
  const themesContainerObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const themesContainerLabel = document.querySelector('.themes-container__label');
        const themesContainerTitle = document.querySelector('.themes-container__title');
        const themesContainerDescription = document.querySelector('.themes-container__description');
        const themesContainerFeatureItems = document.querySelectorAll('.themes-container__feature-item');
        const themesContainerImage = document.querySelector('.themes-container__image');

        // Add animate-in class to trigger CSS animations
        if (themesContainerLabel) themesContainerLabel.classList.add('animate-in');
        if (themesContainerTitle) themesContainerTitle.classList.add('animate-in');
        // Description appears after title (title at 0.2s, description at 0.5s)
        if (themesContainerDescription) {
          setTimeout(() => {
            themesContainerDescription.classList.add('animate-in');
          }, 300); // 300ms after title starts (0.2s + 0.3s = 0.5s total)
        }
        themesContainerFeatureItems.forEach(item => item.classList.add('animate-in'));
        if (themesContainerImage) themesContainerImage.classList.add('animate-in');

        // Stop observing once animated
        themesContainerObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Observe the themes container details container
  const themesContainerDetailsContainer = document.querySelector('.themes-container__details-container');
  if (themesContainerDetailsContainer) {
    themesContainerObserver.observe(themesContainerDetailsContainer);
  }

  // Scroll effect: gradually expand themes-container to fullwidth as user scrolls (same as section-offer)
  // Disable on smaller breakpoints (< 768px)
  const themesContainer = document.querySelector('.themes-container');
  const themesContainerContent = document.querySelector('.themes-container__content');
  
  if (themesContainer && themesContainerContent && window.innerWidth >= 768) {
    let themesContainerTicking = false;

    function updateThemesContainerScrollEffect() {
      const rect = themesContainer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const currentTop = rect.top;
      
      // Calculate scroll progress
      // Start expansion when section top reaches middle of viewport
      // End expansion when section top reaches top of viewport
      const startPoint = windowHeight * 0.5; // Start when section is at middle of viewport
      const endPoint = 0; // End when section top reaches viewport top
      
      // Calculate progress (0 to 1)
      let scrollProgress = 0;
      if (currentTop <= startPoint && currentTop >= endPoint) {
        scrollProgress = (startPoint - currentTop) / (startPoint - endPoint);
      } else if (currentTop < endPoint) {
        scrollProgress = 1; // Fully expanded
      }
      
      scrollProgress = Math.max(0, Math.min(1, scrollProgress));
      
      // Initial values
      const initialPadding = 80; // var(--spacing-20) = 80px
      const finalPadding = 0;
      const initialMaxWidth = 1376;
      const finalMaxWidth = window.innerWidth;
      const initialBorderRadius = 24; // var(--radius-3xl) = 24px
      const finalBorderRadius = 0;
      
      // Interpolate values based on scroll progress
      const currentPadding = initialPadding - (initialPadding - finalPadding) * scrollProgress;
      const currentMaxWidth = initialMaxWidth + (finalMaxWidth - initialMaxWidth) * scrollProgress;
      const currentBorderRadius = initialBorderRadius - (initialBorderRadius - finalBorderRadius) * scrollProgress;
      
      // Apply styles (animate border-radius from 24px to 0px)
      themesContainer.style.paddingLeft = `${currentPadding}px`;
      themesContainer.style.paddingRight = `${currentPadding}px`;
      themesContainerContent.style.maxWidth = `${currentMaxWidth}px`;
      themesContainerContent.style.borderRadius = `${currentBorderRadius}px`;
      
      themesContainerTicking = false;
    }

    function handleThemesContainerScroll() {
      if (!themesContainerTicking) {
        window.requestAnimationFrame(updateThemesContainerScrollEffect);
        themesContainerTicking = true;
      }
    }

    // Use IntersectionObserver to start/stop scroll listener efficiently
    const themesContainerScrollObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting || entry.boundingClientRect.top < window.innerHeight) {
          window.addEventListener('scroll', handleThemesContainerScroll, { passive: true });
          handleThemesContainerScroll(); // Initial call
        } else {
          window.removeEventListener('scroll', handleThemesContainerScroll);
          // Reset to initial state when section is above viewport
          if (entry.boundingClientRect.top < 0) {
            themesContainer.style.paddingLeft = '';
            themesContainer.style.paddingRight = '';
            themesContainerContent.style.maxWidth = '';
            themesContainerContent.style.borderRadius = '';
          }
        }
      });
    }, {
      root: null,
      rootMargin: '200px 0px',
      threshold: 0
    });

    themesContainerScrollObserver.observe(themesContainer);
    
    // Initial call to set correct state on load
    updateThemesContainerScrollEffect();
  }

  // Scroll effect: gradually expand reviews-section to fullwidth as user scrolls (same as themes-container)
  // Disable on smaller breakpoints (< 768px)
  // Declare reviewsSection at top level so it can be reused by animation code below
  const reviewsSection = document.querySelector('.reviews-section');
  const reviewsSectionContent = document.querySelector('.reviews-section__content');
  
  if (reviewsSection && reviewsSectionContent && window.innerWidth >= 768) {
    let reviewsSectionTicking = false;

    function updateReviewsSectionScrollEffect() {
      const rect = reviewsSection.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const currentTop = rect.top;
      
      // Calculate scroll progress
      // Start expansion when section top reaches middle of viewport
      // End expansion when section top reaches top of viewport
      const startPoint = windowHeight * 0.5; // Start when section is at middle of viewport
      const endPoint = 0; // End when section top reaches viewport top
      
      // Calculate progress (0 to 1)
      let scrollProgress = 0;
      if (currentTop <= startPoint && currentTop >= endPoint) {
        scrollProgress = (startPoint - currentTop) / (startPoint - endPoint);
      } else if (currentTop < endPoint) {
        scrollProgress = 1; // Fully expanded
      }
      
      scrollProgress = Math.max(0, Math.min(1, scrollProgress));
      
      // Initial values - use responsive max-width based on viewport
      const initialPadding = 80; // var(--spacing-20) = 80px
      const finalPadding = 0;
      const initialMaxWidth = window.innerWidth >= 1920 ? 1512 : 1376;
      const finalMaxWidth = window.innerWidth;
      const initialBorderRadius = 24; // var(--radius-3xl) = 24px
      const finalBorderRadius = 0;
      
      // Interpolate values based on scroll progress
      const currentPadding = initialPadding - (initialPadding - finalPadding) * scrollProgress;
      const currentMaxWidth = initialMaxWidth + (finalMaxWidth - initialMaxWidth) * scrollProgress;
      const currentBorderRadius = initialBorderRadius - (initialBorderRadius - finalBorderRadius) * scrollProgress;
      
      // Apply styles (animate border-radius from 24px to 0px)
      reviewsSection.style.paddingLeft = `${currentPadding}px`;
      reviewsSection.style.paddingRight = `${currentPadding}px`;
      reviewsSectionContent.style.maxWidth = `${currentMaxWidth}px`;
      reviewsSectionContent.style.borderRadius = `${currentBorderRadius}px`;
      
      reviewsSectionTicking = false;
    }

    function handleReviewsSectionScroll() {
      if (!reviewsSectionTicking) {
        window.requestAnimationFrame(updateReviewsSectionScrollEffect);
        reviewsSectionTicking = true;
      }
    }

    // Use IntersectionObserver to start/stop scroll listener efficiently
    const reviewsSectionScrollObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting || entry.boundingClientRect.top < window.innerHeight) {
          window.addEventListener('scroll', handleReviewsSectionScroll, { passive: true });
          handleReviewsSectionScroll(); // Initial call
        } else {
          window.removeEventListener('scroll', handleReviewsSectionScroll);
          // Reset to initial state when section is above viewport
          if (entry.boundingClientRect.top < 0) {
            reviewsSection.style.paddingLeft = '';
            reviewsSection.style.paddingRight = '';
            reviewsSectionContent.style.maxWidth = '';
            reviewsSectionContent.style.borderRadius = '';
          }
        }
      });
    }, {
      root: null,
      rootMargin: '200px 0px',
      threshold: 0
    });

    reviewsSectionScrollObserver.observe(reviewsSection);
    
    // Initial call to set correct state on load
    updateReviewsSectionScrollEffect();
  }

  // Scroll effect: gradually expand section-offer container to fullwidth as user scrolls
  // Disable on smaller breakpoints (< 768px)
  const sectionOffer = document.querySelector('.section-offer');
  const sectionOfferContainer = document.querySelector('.section-offer__container');
  
  if (sectionOffer && sectionOfferContainer && window.innerWidth >= 768) {
    let ticking = false;

    function updateScrollEffect() {
      const rect = sectionOffer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const sectionHeight = rect.height;
      const currentTop = rect.top;
      
      // Calculate scroll progress
      // Start expansion when section top reaches middle of viewport
      // End expansion when section top reaches top of viewport
      const startPoint = windowHeight * 0.5; // Start when section is at middle of viewport
      const endPoint = 0; // End when section top reaches viewport top
      
      // Calculate progress (0 to 1)
      let scrollProgress = 0;
      if (currentTop <= startPoint && currentTop >= endPoint) {
        scrollProgress = (startPoint - currentTop) / (startPoint - endPoint);
      } else if (currentTop < endPoint) {
        scrollProgress = 1; // Fully expanded
      }
      
      scrollProgress = Math.max(0, Math.min(1, scrollProgress));
      
      // Initial values
      const initialPadding = 80; // var(--spacing-20) = 80px
      const finalPadding = 0;
      const initialMaxWidth = 1376;
      const finalMaxWidth = window.innerWidth;
      const initialBorderRadius = 24; // var(--radius-3xl) = 24px
      const finalBorderRadius = 0;
      
      // Interpolate values based on scroll progress
      const currentPadding = initialPadding - (initialPadding - finalPadding) * scrollProgress;
      const currentMaxWidth = initialMaxWidth + (finalMaxWidth - initialMaxWidth) * scrollProgress;
      const currentBorderRadius = initialBorderRadius - (initialBorderRadius - finalBorderRadius) * scrollProgress;
      
      // Apply styles (animate border-radius from 24px to 0px)
      sectionOffer.style.paddingLeft = `${currentPadding}px`;
      sectionOffer.style.paddingRight = `${currentPadding}px`;
      sectionOfferContainer.style.maxWidth = `${currentMaxWidth}px`;
      sectionOfferContainer.style.borderRadius = `${currentBorderRadius}px`;
      
      ticking = false;
    }

    function handleScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollEffect);
        ticking = true;
      }
    }

    // Use IntersectionObserver to start/stop scroll listener efficiently
    const scrollObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting || entry.boundingClientRect.top < window.innerHeight) {
          window.addEventListener('scroll', handleScroll, { passive: true });
          handleScroll(); // Initial call
        } else {
          window.removeEventListener('scroll', handleScroll);
          // Reset to initial state when section is above viewport
          if (entry.boundingClientRect.top < 0) {
            sectionOffer.style.paddingLeft = '';
            sectionOffer.style.paddingRight = '';
            sectionOfferContainer.style.maxWidth = '';
            sectionOfferContainer.style.borderRadius = '';
          }
        }
      });
    }, {
      root: null,
      rootMargin: '200px 0px',
      threshold: 0
    });

    scrollObserver.observe(sectionOffer);
    
    // Initial call to set correct state on load
    updateScrollEffect();
  }

  // Parallax effect: section-offer moves up over hero, hero illustration moves down slightly
  // Reuse sectionOffer and sectionOfferContainer from above (already declared)
  const hero = document.querySelector('.hero');
  const heroIllustration = document.querySelector('.hero__illustration-placeholder');
  const heroNuvola = document.querySelector('.hero__nuvola');
  const heroBambino = document.querySelector('.hero__bambino');
  
  if (hero && (heroIllustration || heroBambino) && sectionOffer) {
    // Reset any transforms that might have been applied
    sectionOffer.style.transform = '';
    if (heroIllustration) heroIllustration.style.transform = '';
    
    let parallaxTicking = false;

    function updateParallax() {
      const heroRect = hero.getBoundingClientRect();
      const sectionOfferRect = sectionOffer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Only apply parallax when section-offer is approaching hero (when hero bottom is visible)
      const heroBottom = heroRect.bottom;
      const sectionOfferTop = sectionOfferRect.top;
      
      // Calculate progress: start when section-offer top is near hero bottom
      let parallaxProgress = 0;
      const distance = sectionOfferTop - heroBottom;
      
      // Start parallax only when section-offer is very close to hero
      if (distance < 100 && distance > -100) {
        parallaxProgress = Math.max(0, Math.min(1, (100 - distance) / 200));
      } else if (distance <= -100) {
        parallaxProgress = 1;
      }
      
      // Don't move section-offer up - just let it naturally touch hero
      // Only move hero illustration down slightly for parallax effect
      const heroIllustrationOffset = parallaxProgress * 20; // Move down up to 20px
      if (heroIllustration) {
        heroIllustration.style.transform = parallaxProgress > 0 ? `translateY(${heroIllustrationOffset}px)` : '';
      }
      // Bambino no longer moves with parallax
      if (heroNuvola) {
        heroNuvola.style.transform = parallaxProgress > 0 ? `translateY(${heroIllustrationOffset}px)` : '';
      }
      
      // Reset section-offer transform to avoid overlap
      sectionOffer.style.transform = '';
      
      parallaxTicking = false;
    }

    function handleParallaxScroll() {
      if (!parallaxTicking) {
        window.requestAnimationFrame(updateParallax);
        parallaxTicking = true;
      }
    }

    // Use IntersectionObserver to start/stop parallax listener
    const parallaxObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const rect = entry.boundingClientRect;
        // Only activate when hero is visible and section-offer is approaching
        if (rect.bottom > 0 && rect.top < window.innerHeight * 2) {
          window.addEventListener('scroll', handleParallaxScroll, { passive: true });
          handleParallaxScroll();
        } else {
          window.removeEventListener('scroll', handleParallaxScroll);
          // Reset transforms when out of view
          if (rect.top < 0) {
            sectionOffer.style.transform = '';
            if (heroIllustration) heroIllustration.style.transform = '';
            if (heroNuvola) heroNuvola.style.transform = '';
            // Bambino no longer moves
          }
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: [0, 0.25, 0.5, 0.75, 1]
    });

    parallaxObserver.observe(hero);
    
    // Initial call
    updateParallax();
  }

  // Features Container Animation - stessa logica della hero
  const featuresContainer = document.querySelector('.features-container-component');
  const featuresContainerTitle = document.querySelector('.features-container__title');
  const featuresContainerDescription = document.querySelector('.features-container__description');
  const featuresContainerBrush = document.querySelector('.features-container__brush');
  const featuresContainerFeatureItems = document.querySelectorAll('.features-container__feature-item');
  const featuresContainerFeatureTexts = document.querySelectorAll('.features-container__feature-text');

  if (featuresContainer) {
    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    // Function to animate all elements - stessa sequenza della hero
    const animateAll = () => {
      // Animate brush (simple fade in)
      if (featuresContainerBrush) {
        setTimeout(() => {
          featuresContainerBrush.style.opacity = '';
          featuresContainerBrush.classList.add('animate-in');
        }, prefersReducedMotion ? 0 : 50);
      }

      // Animate title (come hero title)
      if (featuresContainerTitle) {
        setTimeout(() => {
          featuresContainerTitle.style.opacity = '';
          featuresContainerTitle.classList.add('animate-in');
        }, prefersReducedMotion ? 0 : 100);
      }

      // Animate description (come hero description)
      if (featuresContainerDescription) {
        setTimeout(() => {
          featuresContainerDescription.style.opacity = '';
          featuresContainerDescription.classList.add('animate-in');
        }, prefersReducedMotion ? 0 : 100);
      }

      // Animate feature items (come hero features) - stessa logica
      featuresContainerFeatureItems.forEach((item, index) => {
        const itemDelay = prefersReducedMotion ? 0 : 100 + (index * 100); // Delay progressivo per gli items
        
        setTimeout(() => {
          item.style.opacity = '';
          item.classList.add('animate-in');
          
          // Animate the text inside each item insieme all'item (come hero)
          const text = item.querySelector('.features-container__feature-text');
          if (text) {
            text.style.opacity = '';
            text.classList.add('animate-in');
          }
          
          // Animate l'icona con delay rispetto all'item - delay totale = itemDelay + 300ms
          const iconContainer = item.querySelector('.features-container__feature-icon-container');
          const icon = item.querySelector('.features-container__feature-icon');
          
          if (iconContainer && icon) {
            const totalIconDelay = prefersReducedMotion ? 0 : itemDelay + 300; // Delay totale dall'inizio
            setTimeout(() => {
              console.log('Animating icon for item', index);
              iconContainer.classList.add('animate-in');
              icon.classList.add('animate-in');
            }, totalIconDelay);
          }
        }, itemDelay);
      });
    };

    // Check if already visible on load
    const rect = featuresContainer.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
    
    if (isVisible) {
      // If already visible, animate after a short delay (come hero)
      setTimeout(animateAll, prefersReducedMotion ? 0 : 100);
    } else {
      // Otherwise, use IntersectionObserver (come section-offer)
      const featuresContainerObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            animateAll();
            // Stop observing once animated
            featuresContainerObserver.unobserve(entry.target);
          }
        });
      }, {
        root: null,
        rootMargin: '-100px',
        threshold: 0.1
      });

      featuresContainerObserver.observe(featuresContainer);
    }
  }

  // Reviews Section Animation - same pattern as themes section
  // Reuse reviewsSection variable from scroll effect code above (line 837)
  const reviewsSectionTitle = document.querySelector('.reviews-section__title');
  const reviewsSectionDescription = document.querySelector('.reviews-section__description');
  const reviewsSectionTestimonials = document.querySelectorAll('.reviews-section__testimonial');

  // Use the reviewsSection variable from the scroll effect
  // Check if it exists before setting up animation observer
  if (reviewsSection && reviewsSectionTitle) {
    const observerOptions = {
      root: null,
      rootMargin: '-100px',
      threshold: 0.1
    };

    const reviewsSectionAnimationObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add animate-in class to trigger CSS animations (same pattern as themes)
          if (reviewsSectionTitle) {
            reviewsSectionTitle.style.opacity = '';
            reviewsSectionTitle.classList.add('animate-in');
          }

          if (reviewsSectionDescription) {
            reviewsSectionDescription.style.opacity = '';
            reviewsSectionDescription.classList.add('animate-in');
          }

          // Animate testimonials with staggered delays
          reviewsSectionTestimonials.forEach((testimonial, index) => {
            setTimeout(() => {
              testimonial.style.opacity = '';
              testimonial.classList.add('animate-in');
            }, 100 + (index * 100));
          });

          // Stop observing once animated
          reviewsSectionAnimationObserver.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe the reviews section
    reviewsSectionAnimationObserver.observe(reviewsSection);
  }

  // Newsletter Section Animation
  const newsletterSection = document.querySelector('.newsletter-section');
  const newsletterSectionTitle = document.querySelector('.newsletter-section__title');
  const newsletterSectionDescription = document.querySelector('.newsletter-section__description');
  const newsletterSectionImageWrapper = document.querySelector('.newsletter-section__image-wrapper');

  if (newsletterSection) {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    const animateNewsletterSection = () => {
      if (newsletterSectionImageWrapper) {
        setTimeout(() => {
          newsletterSectionImageWrapper.style.opacity = '';
          newsletterSectionImageWrapper.classList.add('animate-in');
        }, prefersReducedMotion ? 0 : 50);
      }

      if (newsletterSectionTitle) {
        setTimeout(() => {
          newsletterSectionTitle.style.opacity = '';
          newsletterSectionTitle.classList.add('animate-in');
        }, prefersReducedMotion ? 0 : 100);
      }

      // Description appears after title (title at 100ms, description at 400ms - after title animation completes)
      if (newsletterSectionDescription) {
        setTimeout(() => {
          newsletterSectionDescription.style.opacity = '';
          newsletterSectionDescription.classList.add('animate-in');
        }, prefersReducedMotion ? 0 : 400);
      }
    };

    const rect = newsletterSection.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
    
    if (isVisible) {
      setTimeout(animateNewsletterSection, prefersReducedMotion ? 0 : 100);
    } else {
      const newsletterSectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            animateNewsletterSection();
            newsletterSectionObserver.unobserve(entry.target);
          }
        });
      }, {
        root: null,
        rootMargin: '-100px',
        threshold: 0.1
      });

      newsletterSectionObserver.observe(newsletterSection);
    }
  }

  // Pack Section Animation
  const packSection = document.querySelector('.pack-section');
  const packSectionTitle = document.querySelector('.pack-section__title');
  const packSectionDescription = document.querySelector('.pack-section__description');
  const packSectionDescriptionParagraphs = packSectionDescription ? packSectionDescription.querySelectorAll('p') : [];
  const packSectionSubtitle = document.querySelector('.pack-section__subtitle');
  const packSectionPackages = document.querySelectorAll('.pack-section__package');
  const packSectionCustomContainer = document.querySelector('.pack-section__custom-container');

  if (packSection) {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    const animatePackSection = () => {
      if (packSectionTitle) {
        setTimeout(() => {
          packSectionTitle.style.opacity = '';
          packSectionTitle.classList.add('animate-in');
        }, prefersReducedMotion ? 0 : 100);
      }

      // Animate each paragraph separately, one at a time, after the title
      // Title appears at 100ms, first paragraph at 400ms (after title animation starts), second at 600ms
      packSectionDescriptionParagraphs.forEach((paragraph, index) => {
        const delay = prefersReducedMotion ? 0 : 300 + (index * 200); // 300ms after title, 200ms between paragraphs
        setTimeout(() => {
          paragraph.style.opacity = '';
          paragraph.classList.add('animate-in');
        }, delay);
      });

      // Subtitle appears after description paragraphs finish (title at 100ms, paragraphs at 300ms and 500ms, subtitle at 700ms)
      if (packSectionSubtitle) {
        const subtitleDelay = prefersReducedMotion ? 0 : 300 + (packSectionDescriptionParagraphs.length * 200);
        setTimeout(() => {
          packSectionSubtitle.style.opacity = '';
          packSectionSubtitle.classList.add('animate-in');
        }, subtitleDelay);
      }

      packSectionPackages.forEach((pkg, index) => {
        const delay = prefersReducedMotion ? 0 : 100 + (index * 100);
        setTimeout(() => {
          pkg.style.opacity = '';
          pkg.classList.add('animate-in');
          
          // Animate package title within each package
          const packageTitle = pkg.querySelector('.pack-section__package-title');
          if (packageTitle) {
            packageTitle.style.opacity = '';
            packageTitle.classList.add('animate-in');
          }
        }, delay);
      });

      if (packSectionCustomContainer) {
        const customDelay = prefersReducedMotion ? 0 : 100 + (packSectionPackages.length * 100);
        setTimeout(() => {
          packSectionCustomContainer.style.opacity = '';
          packSectionCustomContainer.classList.add('animate-in');
        }, customDelay);
      }
    };

    const rect = packSection.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
    
    if (isVisible) {
      setTimeout(animatePackSection, prefersReducedMotion ? 0 : 100);
    } else {
      const packSectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            animatePackSection();
            packSectionObserver.unobserve(entry.target);
          }
        });
      }, {
        root: null,
        rootMargin: '-100px',
        threshold: 0.1
      });

      packSectionObserver.observe(packSection);
    }
  }

  // FAQ Section Animation
  const faqSection = document.querySelector('.faq-section');
  const faqSectionTitle = document.querySelector('.faq-section__title');
  const faqSectionAccordions = document.querySelectorAll('.faq-section__accordion');

  if (faqSection) {
    const observerOptions = {
      root: null,
      rootMargin: '-100px',
      threshold: 0.1
    };

    const faqSectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add animate-in class to trigger CSS animations
          if (faqSectionTitle) {
            faqSectionTitle.style.opacity = '';
            faqSectionTitle.classList.add('animate-in');
          }

          // Animate accordions with staggered delays
          faqSectionAccordions.forEach((accordion, index) => {
            setTimeout(() => {
              accordion.style.opacity = '';
              accordion.classList.add('animate-in');
            }, 100 + (index * 100));
          });

          // Stop observing once animated
          faqSectionObserver.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe the FAQ section
    faqSectionObserver.observe(faqSection);
  }

  // Last Call Section Animation
  const lastCallSection = document.querySelector('.last-call-section');
  const lastCallSectionTitle = document.querySelector('.last-call-section__title');
  const lastCallSectionButtons = document.querySelector('.last-call-section__buttons');
  const lastCallSectionButterfly = document.querySelector('.last-call-section__butterfly');
  const lastCallSectionTree = document.querySelector('.last-call-section__tree');

  if (lastCallSection) {
    const observerOptions = {
      root: null,
      rootMargin: '-100px',
      threshold: 0.1
    };

    const lastCallSectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add animate-in class to trigger CSS animations
          if (lastCallSectionTitle) {
            lastCallSectionTitle.style.opacity = '';
            lastCallSectionTitle.classList.add('animate-in');
          }

          if (lastCallSectionButtons) {
            setTimeout(() => {
              lastCallSectionButtons.style.opacity = '';
              lastCallSectionButtons.classList.add('animate-in');
            }, 200); // After title
          }

          if (lastCallSectionButterfly) {
            setTimeout(() => {
              lastCallSectionButterfly.style.opacity = '';
              lastCallSectionButterfly.classList.add('animate-in');
            }, 100);
          }

          if (lastCallSectionTree) {
            setTimeout(() => {
              lastCallSectionTree.style.opacity = '';
              lastCallSectionTree.classList.add('animate-in');
            }, 100);
          }

          // Stop observing once animated
          lastCallSectionObserver.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe the last call section
    lastCallSectionObserver.observe(lastCallSection);
  }

  // Optimize infinite animations - pause when not visible
  const optimizeInfiniteAnimations = () => {
    const animatedElements = [
      { selector: '.hero__nuvola', animationName: 'floatCloud' },
      { selector: '.hero__bambino', animationName: 'floatBambino' },
      { selector: '.hero__stella', animationName: 'rotateStella' }
    ];

    animatedElements.forEach(({ selector, animationName }) => {
      const element = document.querySelector(selector);
      if (!element) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Resume animation
            element.style.animationPlayState = 'running';
          } else {
            // Pause animation when not visible to save resources
            element.style.animationPlayState = 'paused';
          }
        });
      }, {
        root: null,
        rootMargin: '50px',
        threshold: 0
      });

      observer.observe(element);
    });
  };

  // Initialize animation optimization
  optimizeInfiniteAnimations();

  // ============================================
  // SECTION READING - Arc Scroll Animation
  // ============================================
  const sectionReading = document.querySelector('.section-reading');
  const readingArc = document.getElementById('reading-arc');
  const readingContent = document.querySelector('.section-reading__content');
  const readingIllustration = document.querySelector('.section-reading__illustration');
  
  if (sectionReading && readingArc) {
    console.log('✅ Section Reading arc animation initialized');
    let arcAnimationTicking = false;
    
    function updateArcAnimation() {
      const rect = sectionReading.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Calculate scroll progress
      // Animation starts when section enters viewport
      // Animation completes when section top reaches top of viewport
      const sectionTop = rect.top;
      const sectionHeight = rect.height;
      
      // Progress from 0 to 1
      // 0 = section just entered viewport (top at bottom of viewport)
      // 1 = section fully scrolled in (top at top of viewport)
      let progress = 0;
      
      if (sectionTop <= windowHeight && sectionTop + sectionHeight >= 0) {
        // Section is in viewport
        // Calculate progress based on how much has scrolled
        // When sectionTop = windowHeight, progress = 0
        // When sectionTop = 0, progress = 1
        const scrollRange = windowHeight;
        const scrolled = windowHeight - sectionTop;
        progress = Math.max(0, Math.min(1, scrolled / scrollRange));
      } else if (sectionTop > windowHeight) {
        // Section is below viewport - not started
        progress = 0;
      } else {
        // Section is above viewport - completed
        progress = 1;
      }
      
      // Calculate width from 0 to 1280px maintaining aspect ratio
      const targetWidth = 1280;
      const currentWidth = progress * targetWidth;
      
      // Apply width directly - this maintains the aspect ratio
      readingArc.style.width = `${currentWidth}px`;
      readingArc.style.transform = `translateX(-50%)`;
      readingArc.style.opacity = '1';
      
      // Animate content (text) opacity - starts appearing when arc is 30% formed
      // Fully visible when arc is 70% formed
      const contentProgress = Math.max(0, Math.min(1, (progress - 0.3) / 0.4));
      if (readingContent) {
        readingContent.style.opacity = contentProgress.toString();
      }
      
      // Animate illustration (worm) - appears only when arc is fully formed (progress >= 0.95)
      // Then moves from bottom to top, and continues moving left to right as scrolling continues
      if (readingIllustration) {
        if (progress >= 0.95) {
          // Arc is fully formed - worm appears
          // Calculate worm animation progress (0 to 1) starting from when arc is complete
          const wormAppearProgress = Math.max(0, Math.min(1, (progress - 0.95) / 0.05));
          
          // Movement from bottom to top (translateY from 30px to 0)
          const translateY = 30 * (1 - wormAppearProgress);
          
          // Movement from left to right as scrolling continues
          // Use the section's position relative to viewport to create continuous movement
          let translateX = 0;
          if (sectionTop < 0) {
            // Section is above viewport - continue moving right
            // Calculate how far above the viewport (negative sectionTop)
            const distanceAboveViewport = Math.abs(sectionTop);
            // Move right proportionally to scroll distance (max 120px)
            translateX = Math.min(120, distanceAboveViewport * 0.4);
          } else if (progress >= 0.95) {
            // While appearing, start moving slightly
            translateX = (progress - 0.95) * 10; // Small initial movement
          }
          
          // Apply opacity and transforms
          readingIllustration.style.opacity = wormAppearProgress.toString();
          readingIllustration.style.transform = `translateX(calc(-50% + ${translateX}px)) translateY(${translateY}px)`;
        } else {
          // Arc not fully formed yet - worm is hidden
          readingIllustration.style.opacity = '0';
          readingIllustration.style.transform = 'translateX(-50%) translateY(30px)';
        }
      }
      
      // Debug log (only when animating)
      if (progress > 0.1 && progress < 0.9) {
        console.log('Arc animation:', {
          sectionTop: sectionTop.toFixed(0),
          windowHeight: windowHeight,
          progress: progress.toFixed(2),
          width: currentWidth.toFixed(0) + 'px',
          contentOpacity: contentProgress.toFixed(2)
        });
      }
      
      arcAnimationTicking = false;
    }
    
    function handleArcScroll() {
      if (!arcAnimationTicking) {
        window.requestAnimationFrame(updateArcAnimation);
        arcAnimationTicking = true;
      }
    }
    
    // Always listen to scroll when page loads
    window.addEventListener('scroll', handleArcScroll, { passive: true });
    
    // Use IntersectionObserver to optimize
    const arcObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          handleArcScroll();
        }
      });
    }, {
      root: null,
      rootMargin: '200px', // Start animation earlier
      threshold: [0, 0.25, 0.5, 0.75, 1]
    });
    
    arcObserver.observe(sectionReading);
    
    // Initial call
    updateArcAnimation();
    
    // Also call on load
    window.addEventListener('load', () => {
      updateArcAnimation();
    });
  } else {
    console.error('❌ Section Reading or arc element not found!', { sectionReading, readingArc });
  }

  // FAQ Accordion functionality - open one at a time
  const faqAccordions = document.querySelectorAll('[data-faq-accordion]');
  
  if (faqAccordions.length > 0) {
    faqAccordions.forEach(accordion => {
      const button = accordion.querySelector('.faq-section__accordion-button');
      const content = accordion.querySelector('.faq-section__accordion-content');
      
      if (button && content) {
        button.addEventListener('click', () => {
          const isCurrentlyOpen = accordion.hasAttribute('data-faq-open');
          
          // Close all accordions first
          faqAccordions.forEach(acc => {
            acc.removeAttribute('data-faq-open');
            const accButton = acc.querySelector('.faq-section__accordion-button');
            const accContent = acc.querySelector('.faq-section__accordion-content');
            if (accButton) {
              accButton.setAttribute('aria-expanded', 'false');
            }
            // Reset max-height for all accordions to ensure they close properly
            if (accContent) {
              accContent.style.maxHeight = '';
            }
          });
          
          // If this one wasn't open, open it now
          if (!isCurrentlyOpen) {
            accordion.setAttribute('data-faq-open', '');
            button.setAttribute('aria-expanded', 'true');
            
            // Set max-height based on actual content height for smooth animation
            const contentHeight = content.scrollHeight;
            content.style.maxHeight = `${contentHeight}px`;
          }
        });
        
        // Handle resize to update max-height if accordion is open
        let resizeTimeout;
        window.addEventListener('resize', () => {
          if (accordion.hasAttribute('data-faq-open')) {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
              const contentHeight = content.scrollHeight;
              content.style.maxHeight = `${contentHeight}px`;
            }, 100);
          }
        });
      }
    });
  }

  // Pack section: custom stepper (incrementable input 51–100)
  const packStepper = document.querySelector('[data-pack-custom-stepper]');
  if (packStepper) {
    const input = packStepper.querySelector('[data-stepper-input]');
    const minusBtn = packStepper.querySelector('[data-stepper-minus]');
    const plusBtn = packStepper.querySelector('[data-stepper-plus]');
    const packCustomForm = document.querySelector('[data-pack-custom-form]');
    const packCustomQuantity = packCustomForm
      ? packCustomForm.querySelector('[data-pack-custom-quantity]')
      : null;
    const MIN = 51;
    const MAX = 100;

    const getValue = () => parseInt(input.value, 10) || MIN;
    const setValue = (val) => {
      const n = Math.min(MAX, Math.max(MIN, val));
      input.value = String(n);
      if (packCustomQuantity) {
        packCustomQuantity.value = String(n);
      }
      minusBtn.disabled = n <= MIN;
      plusBtn.disabled = n >= MAX;
    };

    minusBtn.addEventListener('click', () => setValue(getValue() - 1));
    plusBtn.addEventListener('click', () => setValue(getValue() + 1));
    setValue(getValue());
  }

  // Mobile sticky button container: show after 50px scroll, or always if floating banner was closed; hide when last-call section top reaches viewport center
  const mobileStickyContainer = document.querySelector('.mobile-sticky__button-container');
  const lastCallSectionForSticky = document.querySelector('.last-call-section');
  if (mobileStickyContainer) {
    const MOBILE_BP = 768;
    const SCROLL_SHOW = 50;
    const BANNER_CLOSED_KEY = 'dot-floating-banner-closed';

    const isMobile = () => window.innerWidth < MOBILE_BP;
    const isBannerClosed = () => sessionStorage.getItem(BANNER_CLOSED_KEY) === 'true';

    const updateStickyVisibility = () => {
      if (!isMobile()) {
        mobileStickyContainer.classList.remove('is-visible');
        return;
      }
      // When the top of last-call section reaches or passes the middle of the viewport, hide sticky; show again when user scrolls back above that
      if (lastCallSectionForSticky) {
        const viewportCenter = window.innerHeight / 2;
        const sectionTop = lastCallSectionForSticky.getBoundingClientRect().top;
        if (sectionTop <= viewportCenter) {
          mobileStickyContainer.classList.remove('is-visible');
          return;
        }
      }
      const scrollY = window.scrollY || window.pageYOffset || 0;
      if (isBannerClosed()) {
        mobileStickyContainer.classList.add('is-visible');
      } else {
        if (scrollY > SCROLL_SHOW) {
          mobileStickyContainer.classList.add('is-visible');
        } else {
          mobileStickyContainer.classList.remove('is-visible');
        }
      }
    };

    updateStickyVisibility();
    let stickyTicking = false;
    window.addEventListener('scroll', () => {
      if (!stickyTicking) {
        requestAnimationFrame(() => {
          updateStickyVisibility();
          stickyTicking = false;
        });
        stickyTicking = true;
      }
    }, { passive: true });
    window.addEventListener('resize', () => {
      clearTimeout(window._mobileStickyResize);
      window._mobileStickyResize = setTimeout(updateStickyVisibility, 150);
    }, { passive: true });
  }

  // Anchor link functionality - handle data-anchor-link attribute
  const anchorLinkButtons = document.querySelectorAll('[data-anchor-link]');
  
  anchorLinkButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const anchorId = button.getAttribute('data-anchor-link');
      
      if (anchorId) {
        // Remove the # if present
        const targetId = anchorId.startsWith('#') ? anchorId.substring(1) : anchorId;
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          // Calculate offset for fixed headers if needed
          const headerOffset = 80; // Adjust based on your header height
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        } else {
          console.warn(`Anchor target not found: #${targetId}`);
        }
      }
    });
  });

  // Floating Banner Close Functionality with Scroll Behavior (Mobile Only)
  const floatingBanner = document.getElementById('dot-floating-banner');
  const closeBannerButton = document.querySelector('[data-close-banner]');

  if (floatingBanner && closeBannerButton) {
    // SessionStorage key for tracking manually closed state (only for current page session; cleared on load so banner reappears after refresh when scrollY is 0)
    const SESSION_STORAGE_KEY = 'dot-floating-banner-closed';
    sessionStorage.removeItem(SESSION_STORAGE_KEY);

    // Mobile breakpoint threshold (matches CSS: < 768px)
    const MOBILE_BREAKPOINT = 768;
    
    // Scroll threshold for hiding banner
    const SCROLL_THRESHOLD = 50;
    
    // Check if banner was manually closed in this session
    const isManuallyClosed = () => {
      return sessionStorage.getItem(SESSION_STORAGE_KEY) === 'true';
    };
    
    // Mark banner as manually closed
    const setManuallyClosed = () => {
      sessionStorage.setItem(SESSION_STORAGE_KEY, 'true');
    };
    
    // Check if we're on mobile viewport
    const isMobileViewport = () => {
      return window.innerWidth < MOBILE_BREAKPOINT;
    };
    
    // Show banner (remove closed attribute)
    const showBanner = () => {
      floatingBanner.setAttribute('data-banner-closed', 'false');
    };
    
    // Hide banner (set closed attribute)
    const hideBanner = () => {
      floatingBanner.setAttribute('data-banner-closed', 'true');
    };
    
    // Handle manual close button click – on mobile show sticky CTA immediately
    closeBannerButton.addEventListener('click', () => {
      setManuallyClosed();
      hideBanner();
      if (isMobileViewport()) {
        const sticky = document.querySelector('.mobile-sticky__button-container');
        if (sticky) sticky.classList.add('is-visible');
      }
    });
    
    // Initialize banner state on load
    // If manually closed, keep it hidden regardless of scroll
    if (isManuallyClosed()) {
      hideBanner();
      return; // Exit early - no scroll behavior needed
    }
    
    // Scroll-based behavior (mobile only)
    let lastScrollY = window.scrollY;
    let ticking = false;
    
    const handleScroll = () => {
      // Only apply scroll behavior on mobile
      if (!isMobileViewport()) {
        // On desktop/tablet, ensure banner is visible (unless manually closed)
        if (!isManuallyClosed()) {
          showBanner();
        }
        return;
      }
      
      // On mobile: check if manually closed first
      if (isManuallyClosed()) {
        hideBanner();
        return;
      }
      
      const currentScrollY = window.scrollY;
      
      // Show banner when at top (scrollY === 0)
      if (currentScrollY === 0) {
        showBanner();
      }
      // Hide banner when scrolled more than threshold
      else if (currentScrollY > SCROLL_THRESHOLD) {
        hideBanner();
      }
      
      lastScrollY = currentScrollY;
      ticking = false;
    };
    
    const requestScrollUpdate = () => {
      if (!ticking) {
        window.requestAnimationFrame(handleScroll);
        ticking = true;
      }
    };
    
    // Initial state check
    handleScroll();
    
    // Listen to scroll events
    window.addEventListener('scroll', requestScrollUpdate, { passive: true });
    
    // Handle window resize to re-evaluate mobile state
    window.addEventListener('resize', () => {
      // Debounce resize
      clearTimeout(window.floatingBannerResizeTimeout);
      window.floatingBannerResizeTimeout = setTimeout(() => {
        handleScroll();
      }, 150);
    }, { passive: true });
  }
});
